import styled, { css } from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

export const Title = styled(Heading).attrs({ size: 'lg' })`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs40}px;
`;

export const UploadAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > img {
    height: 90px;
    width: 90px;
    margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
    margin-top: ${({ theme }) => theme.spacings.abs8}px;
  }
`;

export const UploadAreaText = styled(Text).attrs({
  variant: 'primary',
})`
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;

  & > b {
    color: ${({ theme }) => theme.colors.ctaBlue(-1)};
  }
`;

const iconContainerStyling = css`
  height: ${({ theme }) => theme.spacings.abs32}px;
  width: ${({ theme }) => theme.spacings.abs32}px;
  margin-left: ${({ theme }) => theme.spacings.abs16}px;

  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  // Override default styling
  background-color: ${({ theme }) => theme.colors.white(0)};
  border: 0;
  cursor: pointer;
  :hover {
    background-color: ${({ theme }) => theme.colors.grey(3)};
  }
`;

export const MyMandateContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs8}px;
`;

export const MyMandateText = styled(Text).attrs({
  fontWeight: 'weight-500',
  size: 'lg',
  variant: 'primary',
})`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const IconContainerButton = styled.button`
  ${iconContainerStyling}
`;

export const IconContainerLink = styled.a`
  ${iconContainerStyling}
`;
